var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthKorea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_21583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9031 15.9998C21.9031 17.4755 19.2603 21.1648 16.0003 21.1648C12.7403 21.1648 10.0975 17.4755 10.0975 15.9998C10.0975 12.7398 12.7403 10.097 16.0003 10.097C19.2603 10.097 21.9031 12.7398 21.9031 15.9998Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9031 16C21.9031 19.2601 19.2603 21.9028 16.0003 21.9028C12.7403 21.9028 10.0975 19.2601 10.0975 16",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8267 19.653L22.2615 21.2182L23.3048 22.2615L24.87 20.6963L23.8267 19.653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2175 22.2613L19.6523 23.8265L20.6956 24.8698L22.2608 23.3046L21.2175 22.2613Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9562 22.7819L25.391 24.3471L26.4343 25.3904L27.9995 23.8252L26.9562 22.7819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3475 25.3919L22.7823 26.957L23.8256 28.0003L25.3907 26.4351L24.3475 25.3919Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3909 21.2176L23.8257 22.7828L24.869 23.8261L26.4341 22.2609L25.3909 21.2176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7837 23.8264L21.2186 25.3916L22.2618 26.4349L23.827 24.8697L22.7837 23.8264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2177 6.60834L25.3914 10.782L26.4347 9.73876L22.261 5.56506L21.2177 6.60834Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6523 8.17307L21.2175 9.73828L22.2608 8.695L20.6956 7.12979L19.6523 8.17307Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2614 10.7818L23.8265 12.3469L24.8698 11.3036L23.3047 9.73848L22.2614 10.7818Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7822 5.04349L24.3474 6.6087L25.3907 5.56542L23.8255 4.00021L22.7822 5.04349Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3922 7.65157L26.9573 9.21674L28.0006 8.17345L26.4355 6.60829L25.3922 7.65157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21716 26.9568L5.04346 22.7831L4.00018 23.8264L8.17387 28.0001L9.21716 26.9568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7826 25.3912L9.21735 23.826L8.17406 24.8693L9.73927 26.4345L10.7826 25.3912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1731 22.7829L6.60785 21.2176L5.56457 22.2609L7.12982 23.8262L8.1731 22.7829Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3478 23.8267L8.17407 19.653L7.13079 20.6962L11.3045 24.8699L12.3478 23.8267Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.04322 9.21679L9.21692 5.04309L8.17364 3.99981L3.99994 8.17351L5.04322 9.21679Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60889 10.7824L10.7826 6.60867L9.73931 5.56539L5.56561 9.73909L6.60889 10.7824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17279 12.3475L12.3465 8.17377L11.3032 7.13049L7.12951 11.3042L8.17279 12.3475Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_21583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthKorea);
export default __webpack_public_path__ + "static/media/SouthKorea.fd607a16663ec4395870a559e3fce9b5.svg";
export { ForwardRef as ReactComponent };